import {Button} from '@treatwell/ui/foundations';
import {useSubmitButtonHandler} from './useSubmitButtonHandler';
import styles from './SubmitButton.module.css';
import {useFormContext} from 'react-hook-form';
import {FormInputs} from '../Form';

export const SubmitButton = ({label}: {label: string}) => {
  const {handleSubmit} = useSubmitButtonHandler();
  const {
    formState: {isSubmitting},
  } = useFormContext<FormInputs>();

  return (
    <Button
      onClick={handleSubmit}
      disabled={isSubmitting}
      isLoading={isSubmitting}
      type="submit"
      className={styles.submit}
      data-cy="SubmitButton"
    >
      {label}
    </Button>
  );
};
